import styles from './index.module.css';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJs,
  CategoryScale,
  BarElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import DropdownwithValue from '../DropdownValue';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { getAllLotteryBrands } from '../../redux/features/lotteryBrand/lotteryBrandService';
import { getSaleQuantitybyBrand } from '../../redux/features/dashboard/dashboardService';

const ScatterChart = ({ chartTitle }) => {
  const dispatch = useDispatch();
  const { lotteries } = useSelector((state) => state.lottery.allLotteryBrands);
  const { isSaleQuantityLoading, sale } = useSelector((state) => state.dashboard.saleQuantitybyBrand);

  const [selectedBrand, setSelectedBrand] = useState({ id: '', name: '' });

  ChartJs.register(CategoryScale, BarElement, LinearScale, Title, Tooltip, Legend);

  const fetchAllLotteries = useCallback(() => {
    dispatch(getAllLotteryBrands({ status: true }));
  }, [dispatch]);

  useEffect(() => {
    fetchAllLotteries();
  }, [dispatch, fetchAllLotteries]);

  useEffect(() => {
    if (lotteries && lotteries.length > 0 && !selectedBrand.id) {
      const defaultBrand = lotteries[0];
      setSelectedBrand({ id: defaultBrand.id, name: defaultBrand.name });
  
      dispatch(getSaleQuantitybyBrand({ lottery_brand_code: defaultBrand.code }));
    }
  }, [lotteries, dispatch, selectedBrand.id]);
  

  const handleLotteryBrandCode = (option) => {
    setSelectedBrand({ id: option.id, name: option.name });
    dispatch(getSaleQuantitybyBrand({ lottery_brand_code: option.code }));
  };

  // Convert ISO date to weekday name
  const getDayName = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'short' }); 
  };

  const labels = sale?.map((item) => getDayName(item.day)) || [];

  const soldCounts = sale?.map((item) => Number(item.sold_count)) || [];
  const unsoldCounts = sale?.map((item) => Number(item.unsold_count)) || [];

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Sold Count',
        backgroundColor: '#fcbf00',
        barThickness: 20,
        borderRadius: 4,
        borderSkipped: false,
        data: soldCounts,
      },
      {
        label: 'Unsold Count',
        backgroundColor: '#1D0C50',
        barThickness: 20,
        borderRadius: 4,
        borderSkipped: false,
        data: unsoldCounts,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
        },
        ticks: {
          stepSize: 50,
        },
      },
    },
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardTopic}>
        <p className={styles.title}>{chartTitle}</p>
        <div className={styles.dropdown}>
          <DropdownwithValue
            options={lotteries}
            placeholder='Select Brand'
            onSelect={handleLotteryBrandCode}
            value={selectedBrand.name}
          />
        </div>
      </div>
      <div className={styles.barChart}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default ScatterChart;